<button *ngIf="showMore" mat-icon-button class="close-button" (click)="onClose()">
  <mat-icon class="close-icon" >X</mat-icon>
</button>
<h1
  mat-dialog-title
  style="border-bottom: 1px solid #eeeeee; text-align: center;height: 60px;"
>
  {{ data.name }} <br />
  (CSLB # {{ data.licenseNo }})
</h1>

<div mat-dialog-content style="overflow:auto;height: 400px;">
  <div *ngFor="let review of data.reviews; let i = index">
    <div *ngIf="i < data.previewLimit || showMore">
      <strong>{{ review.createdOn | date: 'shortDate' }} :</strong>
      {{ review.review }} <br />
      <div *ngIf="canShowResponse(review)">
        <strong>
          <a href="#" (click)="updateToggleCollapse(review.id)"
            >See Contractor response</a
          ></strong
        >

        <div *ngIf="toggleCollapse(review.id)" style="padding: 10px;">
          <strong>{{ review.responseDate | date: 'shortDate' }} :</strong>
          {{ review.response }}
        </div>
      </div>
      <mat-divider></mat-divider>
    </div>
  </div>

</div>


<div mat-dialog-actions  style="height: 80px;">
  
  <div *ngIf="!showMore && data.reviews.length >= data.previewLimit" style="width: 100%; text-align: center;" >
      <button mat-button 
        color="primary"
      
        (click)="onMore()">
        View More
      </button>
  
  </div>
  <div  style="width: 100%; text-align: center;">
 
    <button mat-button 
      (click)="onClose()">
      Close
    </button>
  </div>
</div>
